/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/exhaustive-deps */

import { Breadcrumb, Button, Card, Input, message } from 'antd';
import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ReloadOutlined } from '@ant-design/icons';
import { style } from '../../Styles';
import CustomTableComponentsPageable from '../Global/CustomTableComponentsPageable';
import { deleteMake, getAllMakesPaged } from '../../redux/makeSlice';
import DrawerMark from './DrawerMake';
import ActionButton from '../Global/ActionsButton';

const Make = () => {
	const [search, setSearch] = useState('');
	const searchTimerRef = useRef(null);
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(10);
	const [sortBy, setSortBy] = useState('name');
	const [sortDirection, setSortDirection] = useState('ASC');
	const [isMakingApiCall, setMakingApiCall] = useState(true);
	const [displayDrawer, setDisplayDrawer] = useState(false);

	const [selectedMake, setSelectedMake] = useState(null);

	const dispatch = useDispatch();

	const { MakesPaged } = useSelector((state) => state.make);

	const handleTableChange = (_, __, sorter, extra) => {
		if (extra?.action !== 'sort') return;
		if (sorter.order) {
			setSortBy(sorter.columnKey || sorter.field);
			setSortDirection(sorter.order === 'ascend' ? 'ASC' : 'DESC');
		} else {
			setSortBy('name');
			setSortDirection('ASC');
		}
		setCurrentPage(1);
	};

	const fetchAll = () => {
		setMakingApiCall(true);
		dispatch(getAllMakesPaged({ page: currentPage - 1, size: pageSize, sortBy, sortDirection, search }))
			.unwrap()
			.then()
			.catch(() => {
				message.error('Error fetching makes');
			})
			.finally(() => {
				setMakingApiCall(false);
			});
	};

	const showDrawer = () => {
		setDisplayDrawer(true);
	};
	const closeDrawer = () => {
		setSelectedMake(null);
		setDisplayDrawer(false);
	};

	const handleSelectedMake = (record) => {
		setSelectedMake(record);
		showDrawer();
	};
	const handleDelete = (id, calbback) => {
		setMakingApiCall(true);
		dispatch(deleteMake(id))
			.unwrap()
			.then(() => {
				message.success('Make deleted successfully');
				calbback();
			})
			.catch(() => { })
			.finally(() => {
				setMakingApiCall(false);
			});
	};

	useEffect(() => {
		fetchAll();
	}, [dispatch, currentPage, pageSize, sortBy, sortDirection, search]);

	const makesArray = MakesPaged.list.map((item) => ({ ...item, key: item.id }));

	const columns = [
		{
			title: 'ID',
			dataIndex: 'id',
			sorter: true,
		},
		{
			title: 'Name',
			key: 'name',
			render: (record) => {
				return <span>{`${record.name}`}</span>;
			},
			sorter: true,
		},

		{
			title: 'Actions',
			key: 'actions',
			render: (text, record) => (
				<ActionButton
					record={record}
					onDelete={() => handleDelete(record.id)}
					onEdit={() => handleSelectedMake(record)}
				/>
			),
		},
	];
	return (
		<Card
			style={{
				margin: 16,
				maxHeight: '90%', // Set maximum width
				height: 'auto', // Allow width to be dynamic
			}}>
			<div style={style.inlineContent}>
				<div
					style={{
						display: 'flex',
						alignContent: 'center',
						alignItems: 'center',
						float: 'left',
						marginBottom: 8,
					}}>
					<Breadcrumb
						style={{ margin: '0 3em 0 0', fontSize: '1.1em' }}
						items={[
							{
								title: 'Vehicles',
							},
							{
								title: 'Vehicle Make',
							},
						]}
					/>

					<Button
						type='default'
						size='small'
						// style={{ margin: '0 8px 8px 0' }}
						onClick={() => fetchAll()}>
						<ReloadOutlined />
					</Button>
				</div>

				<div
					style={{
						...style.inlineContent,
						float: 'right',
						marginBottom: 8,
					}}>
					<Input.Search
						placeholder='Search'
						style={{ margin: '0 8px 8px 0' }}
						onSearch={(val) => {
							if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
							setCurrentPage(1);
							setSearch(val);
						}}
						onChange={(e) => {
							const val = e.target.value;
							if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
							searchTimerRef.current = setTimeout(() => {
								setCurrentPage(1);
								setSearch(val);
							}, 400);
						}}
					/>
					<Button
						type='default'
						style={{ float: 'right', marginBottom: 8 }}
						onClick={showDrawer}>
						Add Make
					</Button>
				</div>
			</div>
			<CustomTableComponentsPageable
				isMakingApiCall={isMakingApiCall}
				columns={columns.filter((item) => {
					return !item.disabled;
				})}
				dataArray={makesArray}
				handleSelectedRow={() => { }}
				handleDoubleClickRow={(record) => handleSelectedMake(record)}
				onTableChange={handleTableChange}
				pagination={{
					current: currentPage,
					pageSize,
					total: MakesPaged.total || 0,
					onChange: (page, size) => {
						setCurrentPage(page);
						setPageSize(size);
					},
				}}
			/>
			{displayDrawer && <DrawerMark onClose={closeDrawer} makeId={selectedMake?.id} />}
		</Card>
	);
};

export default Make;
